module.exports = __webpack_public_path__ + "img/assign_approver.d7a04ece.svg";